import { jsx as _jsx, jsxs as _jsxs } from "theme-ui/jsx-runtime";
import { ResizeObserver } from "@juggle/resize-observer";
import { createRef, useEffect, useState } from "react";
import { Box } from "theme-ui";
import { ArrowLeft, ArrowRight } from "../../Icons";
import useMeasure from "react-use-measure";
export const ProductCarousel = ({ children, columns }) => {
    const [ref, bounds] = useMeasure({ polyfill: ResizeObserver });
    const [scrollFactor, setScrollFactor] = useState(0);
    const [maxScrollFactor, setMaxScrollFactor] = useState(columns - 3);
    const carouselContainerRef = createRef();
    const carouselRef = createRef();
    const [carouselWidth, setCarouselWidth] = useState(`calc(23% * ${columns})`);
    const [buttonDimensions, setButtonDimensions] = useState({
        height: "100%",
        width: "10%"
    });
    // Reset if product list changes
    useEffect(() => {
        var _a;
        setScrollFactor(0);
        setMaxScrollFactor(columns - 3);
        (_a = carouselContainerRef.current) === null || _a === void 0 ? void 0 : _a.scrollTo({
            left: 0,
            behavior: "smooth"
        });
    }, [columns]);
    // Update dimesions when page width or product list changes
    useEffect(() => {
        const showItems = bounds.width > 900 ? 4 : bounds.width <= 900 && bounds.width > 600 ? 3 : 2;
        const buttonWidth = bounds.width > 600 ? 0.1 : 0.2;
        const itemPercentageWidth = columns > showItems
            ? ((1 - buttonWidth) * 100) / showItems
            : 100 / showItems;
        setCarouselWidth(`calc(${itemPercentageWidth}% * ${columns})`);
        const itemWidth = (bounds.width - Math.pow(2, showItems)) * (itemPercentageWidth / 100);
        const buttonHeight = Math.round(itemWidth * (4 / 3));
        setButtonDimensions({
            height: `${buttonHeight}px`,
            width: `${buttonWidth * 100}%`
        });
        setMaxScrollFactor(columns - showItems);
    }, [bounds.width, columns]);
    const scrollCarousel = (dir) => {
        var _a, _b, _c;
        const itemWidth = (((_a = carouselRef.current) === null || _a === void 0 ? void 0 : _a.offsetWidth) || 300) / columns;
        if (dir > 0) {
            if (scrollFactor + 1 > maxScrollFactor) {
                return;
            }
            setScrollFactor(scrollFactor + 1);
            (_b = carouselContainerRef.current) === null || _b === void 0 ? void 0 : _b.scrollTo({
                left: (scrollFactor + 1) * itemWidth,
                behavior: "smooth"
            });
        }
        else {
            setScrollFactor(scrollFactor - 1);
            (_c = carouselContainerRef.current) === null || _c === void 0 ? void 0 : _c.scrollTo({
                left: (scrollFactor - 1) * itemWidth,
                behavior: "smooth"
            });
        }
    };
    return (_jsxs(Box, { ref: ref, sx: {
            display: "block",
            overflow: "hidden",
            position: "relative"
        }, children: [scrollFactor > 0 && (_jsx("button", { type: "button", sx: {
                    position: "absolute",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    width: buttonDimensions.width,
                    height: buttonDimensions.height,
                    zIndex: 10,
                    px: 8,
                    py: 0,
                    left: 0,
                    top: 0,
                    border: "none",
                    color: "white",
                    backgroundColor: "rgb(0,0,0)",
                    background: "linear-gradient(90deg, rgba(0,0,0,0.35) 0%, rgba(0,0,0,0) 100%)",
                    ":hover": {
                        background: "linear-gradient(90deg, rgba(0,0,0,0.5) 0%, rgba(0,0,0,.1) 100%)"
                    }
                }, onClick: () => scrollCarousel(-1), children: _jsx(ArrowLeft, { width: "50px", height: "50px" }) })), scrollFactor + 1 <= maxScrollFactor && (_jsx("button", { type: "button", sx: {
                    position: "absolute",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                    width: buttonDimensions.width,
                    height: buttonDimensions.height,
                    zIndex: 10,
                    px: 8,
                    py: 0,
                    right: 0,
                    top: 0,
                    border: "none",
                    color: "white",
                    backgroundColor: "rgb(0,0,0)",
                    background: "linear-gradient(270deg, rgba(0,0,0,0.35) 0%, rgba(0,0,0,0) 100%)",
                    ":hover": {
                        background: "linear-gradient(270deg, rgba(0,0,0,0.5) 0%, rgba(0,0,0,.1) 100%)"
                    }
                }, onClick: () => scrollCarousel(1), children: _jsx(ArrowRight, { width: "50px", height: "50px" }) })), _jsx(Box, { ref: carouselContainerRef, sx: {
                    display: "block",
                    overflow: "hidden",
                    position: "relative"
                }, children: _jsx(Box, { ref: carouselRef, sx: {
                        display: "flex",
                        overflow: "hidden",
                        width: carouselWidth,
                        gap: 2,
                        "& > div": {
                            flex: 1
                        }
                    }, children: children }) })] }));
};
//# sourceMappingURL=ProductCarousel.js.map